import {useSuspenseApiQueries as useSuspenseApiQueriesBase} from '@legit-health/backend-client';
export default function useSuspenseApiQueries<TData>({
  queries,
  queryOptions
}: {
  queries: Parameters<typeof useSuspenseApiQueriesBase<TData>>[0]['queries'];
  queryOptions: Parameters<typeof useSuspenseApiQueriesBase<TData>>[0]['queryOptions'];
}) {
  return useSuspenseApiQueriesBase({
    queries: queries.map((q) => ({
      ...q,
      requestArguments: {
        ...q.requestArguments
      }
    })),
    queryOptions
  });
}
